import React from "react"
import { Link } from "react-router-dom"
import { dayLabel, monthLabel, sportLabel } from "./plannerLabels"
import { seasonOfMonth, writePlannerQuery } from "./plannerQuery"

// „Gol în calendar” (wayfinder ticket 17): a county and month whose past tournaments have nothing planned within 30 km and ± 14 days of
// their date + 52 weeks, with their entries. Information only: never a warning, never a proposal. A cell is one sport's (Phase D2); its sport
// is named when the cells cover both sports.
export const gapTitle = (cell, bothSports) => [cell.countyName || cell.county || "No county", monthLabel(`${cell.month}-01`),
  bothSports && sportLabel(cell.sport)].filter(Boolean).join(" · ")
const entriesLabel = count => (count === 1 ? "1 entry" : `${count} entries`)
// "Show in calendar": the Month view of the cell's month, on its county and sport.
export const gapPath = (planner, cell) => "/events-planner" + writePlannerQuery({ ...planner, season: seasonOfMonth(cell.month), sports: [cell.sport],
  categories: [], organizers: [], regions: [], counties: cell.county ? [cell.county] : [], view: "month", month: cell.month, queue: null, tab: "calendar" })

export default function GapCells({ gaps, planner, bothSports }) {
  if (!gaps.length) return <p className="ep-meta mb-0">No gaps: every area and month with tournaments last season has something planned.</p>
  return <div className="ep-stack ep-gap">
    {gaps.map(cell => {
      const title = gapTitle(cell, bothSports)
      return <div role="group" aria-label={title} className="ep-gap-cell" key={`${cell.sport}|${cell.county}|${cell.month}`}>
        <b>{title}</b>
        <span>{`${entriesLabel(cell.entries)}; nothing planned within 30 km and two weeks of their dates`}</span>
        {cell.tournaments.map(tournament => <span className="ep-meta" key={tournament.eventId}>
          {[tournament.eventNumber ? `#${tournament.eventNumber} ${tournament.name}` : tournament.name, dayLabel(tournament.start),
            entriesLabel(tournament.entries)].join(" · ")}</span>)}
        <Link className="ep-link align-self-start" to={gapPath(planner, cell)}>Show in calendar</Link>
      </div>
    })}
  </div>
}
